import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import { initSentry } from '@/sentry';
import AppWrapper from '@/app/App';

// Inicializar Sentry antes de renderizar la app
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);